import type { MessageFormatElement } from 'react-intl';

export type TIntlMessages =
  Record<string, string> | Record<string, MessageFormatElement[]> | undefined;

export const STORE_LOCALE_KEY = 'locale';

export enum ELocales {
  EN = 'en-US',
  RU = 'ru-RU',
  HE = 'he-IL',
  DE = 'de-DE',
}

export const CDefaultLocale: ELocales = ELocales.EN;

export const RTL_LOCALES: readonly ELocales[] = [ELocales.HE];

export const LOCALE_LABELS: Record<ELocales, string> = {
  [ELocales.EN]: 'English',
  [ELocales.RU]: 'Русский',
  [ELocales.HE]: 'עברית',
  [ELocales.DE]: 'Deutsch',
};

export const isRtlLocale = (locale: ELocales): boolean =>
  RTL_LOCALES.includes(locale);
